<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-30 15:20:38
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\upPackingRecords\components\detailRecords.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="60%" :destroy-on-close="true"
             :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <el-form ref="form" label-width="80px" label-position="left">
        <div class="box-title">产品信息</div>
        <div class="gird-container">
          <el-form-item label="产品名称">
            {{ unPackingInfo.materialName }}
          </el-form-item>
          <el-form-item label="规格型号">
            {{ unPackingInfo.specification }}
          </el-form-item>
        </div>

        <div class="box-title">入库记录</div>
        <el-table ref="dataTable" align="center" :data="dataList">
          <el-table-column show-overflow-tooltip prop="code" label="UDI码" />
        </el-table>
        <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
                    :limit.sync="searchParam.pageSize" @pagination="getList" />
      </el-form>
    </el-card>

  </el-drawer>
</template>

<script>
import { getUppackingRecordsDetail } from '@/api/upPackingRecords'
export default {
  name: 'DetailRecords',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    unPackingInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      dataList: [],
      searchParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      }
    }
  },
  created() {
    if (this.unPackingInfo.id) {
      this.getList()
    }
  },
  // 方法集合
  methods: {
    // 获取入库记录
    getList() {
      const unpackingId = this.unPackingInfo.id
      getUppackingRecordsDetail({ unpackingId, ...this.searchParam }).then((res) => {
        this.dataList = res.rows
        this.searchParam.total = res.total
      })
    },
  }
}
</script>

<style scoped>
.gird-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr)
}
</style>
